// ============================================================================
// Supabase Configuration
// Single source of truth for Supabase connection settings
// ============================================================================

export const SUPABASE_URL = 'https://sacqybpdladgofegisdj.supabase.co';
export const SUPABASE_ANON_KEY = 'sb_publishable_75bMnhrLLpRH1THLArkElQ_g-9WQJqD';
